import { useTranslation } from 'react-i18next'
import ConfirmModal from '../../../../../../components/ConfirmModal'
import { useProfileDetails } from '../../../../../../hooks/ApiHooks/useProfileDetails'
import { ModalProps } from '../MoreOptions'

export const DeleteUserModal = ({ props, isOpen, closeModal }: ModalProps) => {
    const { t } = useTranslation('teamManager')
    const { displayName, _profileId, isAssigned } = props
    const { mutateProfile } = useProfileDetails(_profileId, isAssigned)

    const onConfirm = () => {
        mutateProfile([
            _profileId,
            { active: false, quitReason: 'Perfil Inhabilitado desde el Admin' },
        ])
        closeModal()
    }

    return (
        <ConfirmModal
            onConfirm={onConfirm}
            onClose={closeModal}
            open={isOpen}
            type={'danger'}
            title={t('user-options.title-modal-delete', { displayName })}
            contentText={t('user-options.content-modal-delete')}
            confirmButtonText={t('user-options.confirm-btn-modal')}
            cancelButtonText={t('user-options.cancel-btn-modal')}
        />
    )
}
